/**
 * @fileoverview チュートリアル進行を初期状態へ戻すヘルパー
 */

import gameState from '../../core/game-state.js';
import { STATE_PATHS } from '../../shared/constants/state-paths.js';

import { resetSessionState } from './tutorial-session-state.js';
import { resetOnboarding } from './tutorial-storage.js';

/**
 * チュートリアル関連ステートを初期化し、次回タイトルで再開できる状態に戻す。
 * @param {string} action ログ用アクション名
 */
export function resetTutorialProgress(action = 'tutorial_reset_via_settings_button') {
  resetSessionState();
  resetOnboarding();
  gameState.setState(STATE_PATHS.UI_TUTORIAL, { status: 'idle', step: null }, action);
}
